import { render, staticRenderFns } from "./TrophiesList.vue?vue&type=template&id=10525738&scoped=true&"
import script from "./TrophiesList.vue?vue&type=script&lang=js&"
export * from "./TrophiesList.vue?vue&type=script&lang=js&"
import style0 from "./TrophiesList.vue?vue&type=style&index=0&id=10525738&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10525738",
  null
  
)

export default component.exports